import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/UHCS-logo-N01.webp";
import logo2 from "../assets/UHCS-logo-No2.png";
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [registrationOpen, setRegistrationOpen] = useState(false);
  const closeMenu = () => {
    setMenuOpen(false);
    setRegistrationOpen(false);
  };
  const toggleRegistration = () => {
    setRegistrationOpen((prev) => !prev);
  };
  return (
    <header className="navbar-wrapper">
      {" "}
      {/* ========================================= HEADER ========================================= */}{" "}
      <div className="navbar-header">
        {" "}
        {/* LEFT LOGO */}{" "}
        <div className="logo-left">
          {" "}
          <img
            src={logo2}
            alt="UHCS Universal Health Coverage"
            className="uhcs-logo"
          />{" "}
        </div>{" "}
        {/* CENTER TITLE */}{" "}
        <div className="navbar-title">
          {" "}
          <div className="title-small"> UHCS </div>{" "}
          <h1>
            {" "}
            UNIVERSAL HEALTH COVERAGE - STRIVES <br /> IN INDIA{" "}
          </h1>{" "}
          <p> (Govt. of India Reg. No. : CSR/JTA(PTA)/V/SKILL, F-74319) </p>{" "}
        </div>{" "}
        {/* RIGHT LOGO */}{" "}
        <div className="logo-right">
          {" "}
          <img
            src={logo}
            alt="UHCS Universal Health Coverage"
            className="uhcs-logo"
          />{" "}
        </div>{" "}
      </div>{" "}
      {/* ========================================= MOBILE MENU BUTTON ========================================= */}{" "}
      <button
        type="button"
        className={`mobile-menu-button ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
      >
        {" "}
        <span></span> <span></span> <span></span>{" "}
      </button>{" "}
      {/* ========================================= NAVIGATION ========================================= */}{" "}
      <nav className={`main-navigation ${menuOpen ? "menu-open" : ""}`}>
        {" "}
        {/* HOME */}{" "}
        <Link to="/" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>Home</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* ABOUT */}{" "}
        <Link to="/about" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>About</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* CORE TEAM */}{" "}
        <Link to="/core-team" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>Core Team</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* ========================================= ONLINE REGISTRATION DROPDOWN ========================================= */}{" "}
        <div
          className={`nav-item dropdown ${registrationOpen ? "dropdown-open" : ""}`}
        >
          {" "}
          <button
            type="button"
            className="nav-main dropdown-button"
            onClick={toggleRegistration}
            aria-expanded={registrationOpen}
          >
            {" "}
            <span> Online Registration </span>{" "}
            <span
              className={`dropdown-arrow ${registrationOpen ? "rotate" : ""}`}
            >
              {" "}
              ▼{" "}
            </span>{" "}
          </button>{" "}
          {/* DROPDOWN */}{" "}
          <div className={`dropdown-menu ${registrationOpen ? "show" : ""}`}>
            {" "}
            <Link to="/registration/student" onClick={closeMenu}>
              {" "}
              Student Registration{" "}
            </Link>{" "}
            <Link to="/registration/volunteer" onClick={closeMenu}>
              {" "}
              Volunteer Registration{" "}
            </Link>{" "}
            <Link to="/registration/training" onClick={closeMenu}>
              {" "}
              Training Registration{" "}
            </Link>{" "}
          </div>{" "}
        </div>{" "}
        {/* GALLERY */}{" "}
        <Link to="/gallery" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>Gallery</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* ENQUIRY */}{" "}
        <Link to="/enquiry" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>Enquiry Form</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* FRANCHISE */}{" "}
        <Link to="/franchise" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>Franchise</span>{" "}
          </div>{" "}
        </Link>{" "}
        {/* JTA */}{" "}
        <Link to="/jta" className="nav-item" onClick={closeMenu}>
          {" "}
          <div className="nav-main">
            {" "}
            <span>JTA</span>{" "}
          </div>{" "}
        </Link>{" "}
      </nav>{" "}
    </header>
  );
};
export default Navbar;
